// ==============================|| THEME CONSTANT ||============================== //
export const APP_DEFAULT_PATH = '/';
export const DRAWER_WIDTH = 260;
const urls = import.meta.env?.VITE_API_BASE_URL
export const IMAGE_BASE_URL = import.meta.env?.VITE_API_BASE_URL?.replace("/api/v1", "")

export const IMAGE_URL = '/assets/images';




